import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL, envConfig } from "../config";

export interface AuditChange {
  field: string;
  from: any;
  to: any;
}

export interface AuditLog {
  _id: string;
  action: "created" | "updated" | "deleted" | "status_changed" | "assigned";
  resource: string;
  resourceId?: string;
  resourceName?: string;
  userId?: string;
  username?: string;
  changes: AuditChange[];
  createdAt: string;
  updatedAt: string;
}

export interface AuditLogsResponse {
  data: AuditLog[];
  total: number;
}

export const auditApi = createApi({
  reducerPath: "auditApi",
  baseQuery: fetchBaseQuery({
    credentials: "include",
    baseUrl: BASE_URL + "audit",
    prepareHeaders: (headers) => {
      headers.set("api-key", `${envConfig.API_KEY}`);
      return headers;
    },
  }),
  tagTypes: ["AuditLogs"],
  endpoints: (builder) => ({
    getAuditLogs: builder.query<
      AuditLogsResponse,
      { resource?: string; userId?: string; limit?: number; skip?: number }
    >({
      query: ({ resource, userId, limit = 50, skip = 0 } = {}) => {
        const params = new URLSearchParams();
        if (resource) params.set("resource", resource);
        if (userId) params.set("userId", userId);
        params.set("limit", String(limit));
        params.set("skip", String(skip));
        return `/?${params.toString()}`;
      },
      providesTags: ["AuditLogs"],
    }),
    getAuditLogsByResource: builder.query<AuditLog[], string>({
      query: (resourceId) => `/resource/${resourceId}`,
      providesTags: ["AuditLogs"],
    }),
  }),
});

export const { useGetAuditLogsQuery, useGetAuditLogsByResourceQuery } = auditApi;
